import api from '../API';

export async function start(platform: string): Promise<number> {
  const response = await api.post(`platforms/${platform}/sessions`);
  return response.data.sessionId;
}

export function terminate(sessionId: number): void {
  navigator.sendBeacon(
    `${window.env.REMOTE_BROWSER.API_URL}/sessions/${sessionId}`,
  );
}
